import { render } from "./RainySeasonScreen.vue?vue&type=template&id=35c4474c&scoped=true&ts=true&lang=pug"
import script from "./RainySeasonScreen.vue?vue&type=script&lang=ts"
export * from "./RainySeasonScreen.vue?vue&type=script&lang=ts"

import "./RainySeasonScreen.vue?vue&type=style&index=0&id=35c4474c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c4474c"]])

export default __exports__